const newsfilter = {
	filterLinks: '',
	filterElements: '',

	init: () => {
		newsfilter.filterLinks = document.querySelectorAll('#grow__news .category__filter a')
		newsfilter.filterElements = document.querySelectorAll('#grow__news .news__teaser-item')
		newsfilter.addListener(newsfilter.filterLinks)
	},

	addListener(els) {
		els.forEach(link => {
			link.addEventListener('click', () => {
				const cat = link.dataset.category
				els.forEach(el => el.classList.remove('active'))
				link.classList.add('active')
				newsfilter.filterElements.forEach(el => {
					const data = el.dataset.category
					if (data.indexOf(cat) > -1) {
						el.style.display = ""
					} else {
						el.style.display = "none"
					}
				})
			 })
		})
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('grow__news')) {
		newsfilter.init()
	}
})